import { render, staticRenderFns } from "./lgcocina.vue?vue&type=template&id=e0d51a32&"
import script from "./lgcocina.vue?vue&type=script&lang=js&"
export * from "./lgcocina.vue?vue&type=script&lang=js&"
import style0 from "./lgcocina.vue?vue&type=style&index=0&id=e0d51a32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports